// storybook-check-ignore
import { useEffect, useRef } from 'react';

import { Box, Link, Text } from '@opendoor/bricks-next';

import { EntryComponent } from 'cms/entries/entries';

import Container from 'components/landing-pages-v2/shared/Container';

import { ITrustpilotWidget } from 'declarations/contentful';

const RenderTrustpilotWidget = (entry: ITrustpilotWidget) => {
  const { title } = entry.fields;
  const desktopContainerRef = useRef<HTMLDivElement | null>(null);
  const mobileContainerRef = useRef<HTMLDivElement | null>(null);

  const trustpilotCommonData = {
    'data-locale': 'en-US',
    'data-template-id': '53aa8912dec7e10d38f59f36',
    'data-businessunit-id': '5972843f0000ff0005a7274a',
    'data-style-height': '140px',
    'data-style-width': '100%',
    'data-stars': '1,2,3,4,5',
    'data-review-languages': 'en',
  } as const;

  useEffect(() => {
    if (typeof window === 'undefined') return;

    const tryLoad = () => {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      const w = window as any;
      let didAttempt = false;
      if (w?.Trustpilot?.loadFromElement) {
        if (desktopContainerRef.current) {
          w.Trustpilot.loadFromElement(desktopContainerRef.current);
          didAttempt = true;
        }
        if (mobileContainerRef.current) {
          w.Trustpilot.loadFromElement(mobileContainerRef.current);
          didAttempt = true;
        }
      }
      return didAttempt;
    };

    if (tryLoad()) return;

    const intervalId = window.setInterval(() => {
      if (tryLoad()) {
        window.clearInterval(intervalId);
      }
    }, 500);

    return () => {
      window.clearInterval(intervalId);
    };
  }, []);

  return (
    <Box>
      <Container backgroundColor="$backgroundSecondary">
        {title && (
          <Box py="$16x">
            <Text
              tag="span"
              display="block"
              typography="$displaySmall"
              $smallerThanMD={{ typography: '$headerSmall' }}
            >
              {title}
            </Text>
          </Box>
        )}
        {[
          {
            key: 'desktop',
            ref: desktopContainerRef,
            token: 'f5ac60d1-d0ba-4154-a67a-3b5d7d6f2e28',
            extraProps: { $smallerThanMD: { display: 'none' as const }, pb: '$16x' as const },
          },
          {
            key: 'mobile',
            ref: mobileContainerRef,
            token: '9361d9bc-b89c-41fd-ad2e-8daafedba526',
            extraProps: { display: 'none' as const, $smallerThanMD: { display: 'block' as const } },
          },
        ].map(({ key, ref, token, extraProps }) => (
          <Box
            key={key}
            ref={ref}
            className="trustpilot-widget"
            {...trustpilotCommonData}
            data-token={token}
            {...extraProps}
          >
            <Link
              href="https://www.trustpilot.com/review/opendoor.com"
              target="_blank"
              rel="noopener"
              analyticsName="cosmos-landing-page-v2-trustpilot-link"
            >
              Trustpilot
            </Link>
          </Box>
        ))}
      </Container>
    </Box>
  );
};

const TrustpilotWidget: EntryComponent<ITrustpilotWidget> = {
  render: RenderTrustpilotWidget,
};

export default TrustpilotWidget;
